import React, { Component } from 'react'
import '../../assets/css/welcome.css'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import VideoCarousel from "./VideoCarousel";
// import { Link } from 'react-router-dom';
export default class Welcome extends Component {
  handleOnClick = () => {
    window.scrollTo(0, 2060);
     
  }
  render() {
    return (
      <div>
        <VideoCarousel />
               {/* <h3 style={{ letterSpacing: "10px" }}> Signature Move Investment Group btnActive
 </h3> */}
        <h1>

        </h1>
        {/* <h2 className="btnStyle " style={{ marginRight: "26px", padding: "26px 68px 26px 68px"}}>Find Your Signature Move Today</h2> */}
        {/* <div className='btns'> */}
          {/* <Link to="/request" className="btnStyle  " style={{ marginRight: "26px", padding: "26px 68px 26px 68px" }}>Find Your Signature Move Today</Link> */}
          {/* <Link onClick={this.handleOnClick} to="#caro" className="btnStyle " style={{ marginRight: "26px", padding: "26px 68px 26px 68px" }}>Offers</Link> */}
        {/* </div> */}
      </div>
    )
  }
}
